export enum BillingTypes {
  HOURLY = 'hourly',
  FIX = 'fix',
}
